// source: messages/schemas/message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

var messages_enums_message_level_pb = require("../../messages/enums/message_level_pb.js");
goog.object.extend(proto, messages_enums_message_level_pb);
var messages_schemas_source_pb = require("../../messages/schemas/source_pb.js");
goog.object.extend(proto, messages_schemas_source_pb);
goog.exportSymbol("proto.Message", null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Message = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Message, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Message.displayName = "proto.Message";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Message.prototype.toObject = function (opt_includeInstance) {
    return proto.Message.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Message} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Message.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        source:
          (f = msg.getSource()) &&
          messages_schemas_source_pb.Source.toObject(includeInstance, f),
        level: jspb.Message.getFieldWithDefault(msg, 2, 0),
        message: jspb.Message.getFieldWithDefault(msg, 3, ""),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Message}
 */
proto.Message.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Message();
  return proto.Message.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Message}
 */
proto.Message.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new messages_schemas_source_pb.Source();
        reader.readMessage(
          value,
          messages_schemas_source_pb.Source.deserializeBinaryFromReader,
        );
        msg.setSource(value);
        break;
      case 2:
        var value = /** @type {!proto.MessageLevel} */ reader.readEnum();
        msg.setLevel(value);
        break;
      case 3:
        var value = /** @type {string} */ reader.readString();
        msg.setMessage(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Message.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Message.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_schemas_source_pb.Source.serializeBinaryToWriter,
    );
  }
  f = message.getLevel();
  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional Source source = 1;
 * @return {?proto.Source}
 */
proto.Message.prototype.getSource = function () {
  return /** @type{?proto.Source} */ jspb.Message.getWrapperField(
    this,
    messages_schemas_source_pb.Source,
    1,
  );
};

/** @param {?proto.Source|undefined} value */
proto.Message.prototype.setSource = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.Message.prototype.clearSource = function () {
  this.setSource(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Message.prototype.hasSource = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional MessageLevel level = 2;
 * @return {!proto.MessageLevel}
 */
proto.Message.prototype.getLevel = function () {
  return /** @type {!proto.MessageLevel} */ jspb.Message.getFieldWithDefault(
    this,
    2,
    0,
  );
};

/** @param {!proto.MessageLevel} value */
proto.Message.prototype.setLevel = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};

/**
 * optional string message = 3;
 * @return {string}
 */
proto.Message.prototype.getMessage = function () {
  return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};

/** @param {string} value */
proto.Message.prototype.setMessage = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

goog.object.extend(exports, proto);
